import settings from '../settings';
import moment from 'moment';
import 'tooltipsy';
import nunjucks from 'nunjucks';
import preloadNunjucks from '../preload/nunjucks';
var nunjucksEnv = preloadNunjucks();

export default class Snapshot {
  constructor () {
    this.bindEvents();

    $('#snapshot-tooltip').tooltipsy({
      offset: [-10, 0],
      className: 'tooltipsy tooltipsy--left'
    });

    this.current_user = $('.user-profile').data('user-id');
    this.posts_loaded = false;
    this.shares_loaded = false;
    this.reach_loaded = false;
    this.leaderboard_loaded = false;
    this.appended_shares_post_ids = [];
  }

  bindEvents () {
    const that = this;

    $('[data-slideout]').on('slideout:opened', function () {
      window.setTimeout(function () {
          $('#snapshot-tooltip').data('tooltipsy').hide();
      }, 500);

      $('.dropdown.is-active').addClass('visually-hidden').removeClass('is-active')
         .addClass('is-hidden');
      $('.dropdown__trigger__label').data('active', false);
      $('.dropdown__trigger').prop('checked', false);
      $('.trend-selection__options').hide();

      if ($(this).data('slideout') == '#snapshot-slideout') {
        that.populateShares();
      }
    });

    $('[data-snapshot-accordion]').on('accordion:opened', function () {
      const accordionType = $(this).data('snapshot-accordion');

      switch (accordionType) {
        case 'shares': that.populateShares(); break;
        case 'posts': that.populatePosts(); break;
        case 'reach': that.populateReach(); break;
        case 'leaderboard': that.populateLeaderboard(); break;
      }
    });

    $('[data-snapshot-accordion]').on('click', '.slideout__shares', function () {
      $('.slideout__pane1').addClass('slideout__pane1--closed');
      $('.slideout__pane2').addClass('slideout__pane2--open');

      $('.slideout__pane2').find('[data-section]').text($(this).data('section'));

      const postId = $(this).data('post-id');

      $('.post-shares').hide();
      $('.post-info').hide();

      console.log('.post-shares[data-post-id=' + postId + ']');

      $('.post-shares[data-post-id=' + postId + ']').show();
      $('.post-info[data-post-id=' + postId + ']').show();

      return false;
    });

    $('[data-slideout-back]').click(function () {
      $('.slideout__pane1').removeClass('slideout__pane1--closed');
      $('.slideout__pane2').removeClass('slideout__pane2--open');

      return false;
    });
  }

  populateShares () {
    if (this.shares_loaded) {
      return false;
    }

    this.shares_loaded = true;

    $.ajax({
      headers: settings.api_headers,
      url: `/users/${this.current_user}/snapshot/shares`,
      type: 'GET',
      dataType: 'json'
    }).then(response => {
      const recent = nunjucksEnv.render('html/snapshot/posts.html', {posts: response.recent, section: 'Post Shares' });
      $('[data-snapshot-shares-recent]').html(recent);

      const top = nunjucksEnv.render('html/snapshot/posts.html', {posts: response.top, section: 'Post Shares' });
      $('[data-snapshot-shares-top]').html(top);

      this.appendShares(response.recent.concat(response.top));
    });
  }

  populatePosts () {
    if (this.posts_loaded) {
      return false;
    }

    this.posts_loaded = true;

    $.ajax({
      headers: settings.api_headers,
      url: `/users/${this.current_user}/snapshot/posts`,
      type: 'GET',
      dataType: 'json'
    }).then(response => {
      const recent = nunjucksEnv.render('html/snapshot/posts.html', {posts: response.recent, section: 'My Posts' });
      $('[data-snapshot-posts-recent]').html(recent);

      const top = nunjucksEnv.render('html/snapshot/posts.html', {posts: response.top, section: 'My Posts' });
      $('[data-snapshot-posts-top]').html(top);

      this.appendShares(response.recent.concat(response.top));
    });
  }

  populateReach () {
    if (this.reach_loaded) {
      return false;
    }

    this.reach_loaded = true;

    $.ajax({
      headers: settings.api_headers,
      url: `/users/${this.current_user}/snapshot/reach`,
      type: 'GET',
      dataType: 'json'
    }).then(response => {
      const recent = nunjucksEnv.render('html/snapshot/posts.html', {posts: response.recent, section: 'Post Reach' });
      $('[data-snapshot-reach-recent]').html(recent);

      const top = nunjucksEnv.render('html/snapshot/posts.html', {posts: response.top, section: 'Post Reach' });
      $('[data-snapshot-reach-top]').html(top);

      this.appendShares(response.recent.concat(response.top));
    });
  }

  populateLeaderboard () {
    if (this.leaderboard_loaded) {
      return false;
    }

    this.leaderboard_loaded = true;

    $.ajax({
      headers: settings.api_headers,
      url: `/users/${this.current_user}/snapshot`,
      type: 'GET',
      dataType: 'json'
    }).then(response => {
      const leaderboardBar = nunjucksEnv.render('html/snapshot/leaderboard-bar.html', {data: response});
      $('[data-leaderboard-bar]').html(leaderboardBar);

      const leaderboardThirty = nunjucksEnv.render('html/snapshot/leaderboard.html', {data: response.summaries.last_30_days, days: 30});
      $('[data-leaderboard-thirty]').html(leaderboardThirty);

      const leaderboardSeven = nunjucksEnv.render('html/snapshot/leaderboard.html', {data: response.summaries.last_7_days, days: 7});
      $('[data-leaderboard-seven]').html(leaderboardSeven);
      $('.tooltip').tooltipsy({ offset: [0, -10]});
    });
  }

  appendShares (posts) {
    posts = posts.filter(post => {
      if (this.appended_shares_post_ids.indexOf(post.id) > -1) {
        return false;
      }

      this.appended_shares_post_ids.push(post.id);

      return true;
    });

    posts = posts.map(post => {
      post.my_shares = post.my_shares.map(share => {
        share.created_ago = moment(share.created).fromNow();
        return share;
      });

      return post;
    })

    const postShares = nunjucksEnv.render('html/snapshot/post-shares.html', {posts: posts});
    $('[data-post-shares-container]').append(postShares);

    const postInfo = nunjucksEnv.render('html/snapshot/post-info.html', {posts: posts});
    $('[data-post-shares-info-container]').append(postInfo);
  }
}
